<div
  class="flex items-center gap-2 relative"
  [style.top.px]="moveIcons ? 172 : null"
  [style.left.px]="moveIcons ? -16 : null">
  <sbnb-icon-airbnb
    *ngIf="hasAirbnbListing"
    [size]="12"
    [muted]="edited"
    [matTooltip]="edited ? status.AirbnbEdited : status.Airbnb"></sbnb-icon-airbnb>
  <sbnb-icon-booking *ngIf="hasBookingListing" [size]="12" [matTooltip]="status.Booking"></sbnb-icon-booking>
  <sbnb-icon-agoda *ngIf="hasAgodaListing" [size]="12" [matTooltip]="status.Agoda"></sbnb-icon-agoda>
  <sbnb-icon-smartbnb *ngIf="hasDirectSites" [size]="12" [matTooltip]="status.DirectSites"></sbnb-icon-smartbnb>
</div>
